import {
  searchRestaurant,
  addRestaurant,
  relatedTerminal,
  delRestaurant
} from '../api'
import { INIT_RESTAURANT_LIST } from './mutation_types'

const state = {
  restaurantList: [],
  total: 0
}

const actions = {
  initRestaurantList({ commit }, reqParam) {
    searchRestaurant(reqParam).then(res => {
      commit(INIT_RESTAURANT_LIST, res.data)
    })
  },
  createRestaurant({ commit }, { reqParams, cb, errorCb }) {
    let phone = reqParams.otherTel ? `${reqParams.tel},${reqParams.otherTel}` : reqParams.tel
    let reqParam = Object.assign(reqParams, {phone})

    addRestaurant(reqParam).then(res => {
      const { success, msg } = res.data

      if (!success) {
        errorCb && errorCb(msg)
        return
      }

      cb && cb()
    })
  },
  relatedTerminal({ commit }, { reqParams, cb, errorCb }) {
    relatedTerminal(reqParams).then(res => {
      const { success, msg } = res.data

      if (!success) {
        errorCb && errorCb(msg)
        return
      }

      cb && cb()
    })
  },
  delRestaurant({ commit }, { id, errorCb, cb }) {
    delRestaurant({ restaurantId: id }).then(res => {
      const { success, msg } = res.data

      if (!success) {
        errorCb && errorCb(msg)
        return
      }

      cb && cb()
    })
  }
}

const mutations = {
  [INIT_RESTAURANT_LIST](state, data) {
    state.restaurantList = data.data_collect || []
    state.total = data.data_count
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurantManage.js